import { SxProps, Theme } from "@mui/material";

// One slow pulse for everything provisional on screen — stale live readings
// and predicted prices alike. A CSS animation starts when its element mounts,
// so elements appearing at different moments would drift apart; a negative
// delay anchored to the wall clock puts every one of them at the same point
// of the cycle, so the whole page breathes in step.
const PULSE_MS = 2000;

export const pulseSx = () =>
  ({
    "@keyframes syncPulse": {
      "0%, 100%": { opacity: 1 },
      "50%": { opacity: 0.4 },
    },
    animation: `syncPulse ${PULSE_MS}ms ease-in-out infinite`,
    animationDelay: `-${Date.now() % PULSE_MS}ms`,
  }) as const satisfies SxProps<Theme>;

// Live readings that have stopped updating.
export const stalePulseSx = () =>
  ({ ...pulseSx(), color: "text.disabled" }) as const satisfies SxProps<Theme>;

// Confirmation that a refresh the user asked for landed: the source's own
// timestamp rises into view under its price, holds for ~3s, then sinks away.
// Only opacity and transform animate, and the caller reserves the line at a
// fixed height, so nothing around it can move.
export const sourceFlashDurationMs = 3600;

export const sourceFlashSx: SxProps<Theme> = {
  "@keyframes sourceFlash": {
    "0%": { opacity: 0, transform: "translateY(7px) scale(0.94)" },
    "9%": { opacity: 1, transform: "translateY(0) scale(1)" },
    "85%": { opacity: 1, transform: "translateY(0) scale(1)" },
    "100%": { opacity: 0, transform: "translateY(5px) scale(0.98)" },
  },
  "@keyframes sourceFlashFade": {
    "0%": { opacity: 0 },
    "9%, 85%": { opacity: 1 },
    "100%": { opacity: 0 },
  },
  animation: `sourceFlash ${sourceFlashDurationMs}ms cubic-bezier(0.2, 0.8, 0.2, 1) forwards`,
  "@media (prefers-reduced-motion: reduce)": {
    animation: `sourceFlashFade ${sourceFlashDurationMs}ms ease-out forwards`,
  },
};
